import React from "react";

import "./styles.css";

import { ReactComponent as WhiteLogoSVG } from "../../assets/logo/M_WHITE_LOGO_FULL.svg";

import LogoutIcon from "@mui/icons-material/Logout";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import MainButton from "../SmallComponents/MainButton";

import { useChallenge } from "../../contexts/ChallengeContext";
import { useAuth } from "../../contexts/AuthContext";


import * as Material from "@mui/material";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LandscapeIcon from "@mui/icons-material/Landscape";
import SettingsIcon from "@mui/icons-material/Settings";

export default function Header({ hideLogoutBtn }) {
  const headerRef = React.useRef(null);

  const {
    loading,
    currentChallenge,
    handleOpenChallengesSelect,
  } = useChallenge();



  const {signOut, user} = useAuth()

  const handleScroll = () => {
    if (window.scrollY === 0) {
      // Remove box shadow
      headerRef.current.style.boxShadow = "none";
    } else {
      // Add box shadow
      headerRef.current.style.boxShadow =
        "rgba(22, 22, 22, 0.17) 0px 18px 20px -20px";
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {}, [currentChallenge]);

  function handleRequestSupport() {
    window.open(
      "https://api.whatsapp.com/send/?phone=5531971583279&text&type=phone_number&app_absent=0"
    );
  }

  return (
    <header>
      <div className="header" ref={headerRef}>
        <div className="left-container">
          <WhiteLogoSVG className="header-logo" />
          <h3>Olá, {user.username?.split(' ')[0]}</h3>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          {
            <MainButton
              shadow={false}
              variant="contained"
              color="white"
              onClick={handleRequestSupport}
              endIcon={<SupportAgentIcon />}
              label={"Suporte"}
            />
          }
          {!hideLogoutBtn && (
            <MainButton
              shadow={false}
              variant="contained"
              color="white"
              onClick={signOut}
              endIcon={<LogoutIcon />}
              label={"Sair"}
            />
          )}
        </div>
      </div>
    </header>
  );
}
